var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen",style:({
    'background-image': "url('/img/background-guest-open-task.svg')"
  })})}
var staticRenderFns = []

export { render, staticRenderFns }